import type { Metric } from '../types';

interface MetricEventDefaultProps {
  metric: Metric;
}

export const MetricEventDefault: React.FC<MetricEventDefaultProps> = ({ metric }) => {
  if (!metric.eventDefault) {
    return null;
  }

  if (metric.eventDefault.disabled) {
    return <span>Excluded</span>;
  }

  return <span>Included with value set to {metric.eventDefault.value ?? 0}</span>;
};
